const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/campaignOverride');
const linkResolve = require('./contentful/link-resolve');
const processError = require('./contentful/error-process');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  all(depth = 0) {
    return getSpace().then((space) => {
      return space.getEntries({
        content_type: 'campaignOverride', // eslint-disable-line
        // order: order || '-sys.updatedAt',
        'limit': 999,
        'sys.archivedAt[exists]': false
      }).catch(
        processError
      ).then((entries) => {
        const data = entries.toPlainObject();

        return linkResolve(space, data, depth).then((entries) => {
          return entries.items.map(transformer.contentfulToInternal);
        });
      });
    });
  },

  allActive(depth = 0, limit = 100) {
    const nowDate = new Date();
    const now = nowDate.toISOString();
    return getSpace().then((space) => {
      const entryParams = {
        'content_type': 'campaignOverride',
        'fields.startDate[lte]': now,
        'fields.expiryDate[gte]': now,
        // 'order': '-fields.priority,fields.expiryDate',
        'include': depth,
        'limit': limit,
        'sys.archivedAt[exists]': false
      };

      return space.getEntries(entryParams).catch(
        processError
      ).then((entries) => {
        const data = entries.toPlainObject();

        return linkResolve(space, data, depth).then((entries) => {
          return [entries.items.map(transformer.contentfulToInternal), entries.total];
        });
      });
    });
  },

  allUpcoming(depth = 0, limit = 100) {
    const nowDate = new Date();
    const now = nowDate.toISOString();
    return getSpace().then((space) => {
      const entryParams = {
        'content_type': 'campaignOverride',
        'fields.startDate[gte]': now,
        // 'order': '-fields.priority,fields.expiryDate',
        'include': depth,
        'limit': limit,
        'sys.archivedAt[exists]': false
      };

      return space.getEntries(entryParams).catch(
        processError
      ).then((entries) => {
        const data = entries.toPlainObject();

        return linkResolve(space, data, depth).then((entries) => {
          return [entries.items.map(transformer.contentfulToInternal), entries.total];
        });
      });
    });
  },

  createEmpty() {
    const expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + 7);
    return {
      published: false,
      updated: false,
      draft: true,

      name: ''
    };
  },

  save(override, ...parameters) {
    if (override.id) {
      return gettingEntryService().then((service) => service.save(override, ...parameters));
    }

    return gettingEntryService().then((service) => service.create('campaignOverride', override, ...parameters));
  },

  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  },

  archive(...parameters) {
    return gettingEntryService().then((service) => service.archive(...parameters));
  },

  unarchive(...parameters) {
    return gettingEntryService().then((service) => service.unarchive(...parameters));
  }
};
